// Models
import Model from './Model'

class AccountCard extends Model {
  get schema () {
    return [
      'id',
      'cardOrderId',
      'currency',
      'maskedPan',
      'reserved',
      'walletId'
    ]
  }
}

export default AccountCard
